"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.popularExerciseTemplateIds = exports.filterExercises = exports.newFilterExercises = exports.createFuseInstance = void 0;
const fuse_js_1 = __importDefault(require("fuse.js"));
const utils_1 = require("./utils");
const lodash_1 = require("lodash");
const createFuseInstance = () => {
    const stringSimilarityFuseInstance = new fuse_js_1.default([''], {
        includeScore: true,
        threshold: 0.4,
        location: 0, // Prefer matches at the beginning of the string
    });
    return stringSimilarityFuseInstance;
};
exports.createFuseInstance = createFuseInstance;
const newFilterExercises = ({ fuseInstance, exercises, muscleGroupFilter, equipmentType, searchText, language, muscleGroupMatchPenalty, }) => {
    let result = exercises;
    result = filterExercisesWithMuscleGroup(muscleGroupFilter, result);
    result = filterExercisesWithEquipment(equipmentType, result);
    const normalizedSearchText = normalizeSearchText(searchText, language);
    result = newFilterExercisesWithSearchText(fuseInstance, normalizedSearchText, result, language, muscleGroupMatchPenalty);
    result = orderExercisesWithSearchText(normalizedSearchText, result);
    return result;
};
exports.newFilterExercises = newFilterExercises;
const filterExercises = ({ exercises, muscleGroupFilter, equipmentType, searchText, language, }) => {
    let result = exercises;
    result = filterExercisesWithMuscleGroup(muscleGroupFilter, result);
    result = filterExercisesWithEquipment(equipmentType, result);
    const normalizedSearchText = normalizeSearchText(searchText, language);
    result = filterExercisesWithSearchText(normalizedSearchText, result, language);
    result = orderExercisesWithSearchText(normalizedSearchText, result);
    return result;
};
exports.filterExercises = filterExercises;
const filterExercisesWithMuscleGroup = (muscleGroup, exercises) => {
    if (muscleGroup === 'all_muscles') {
        return exercises;
    }
    return exercises.filter((rd) => rd.muscle_group === muscleGroup);
};
const filterExercisesWithEquipment = (equipmentType, exercises) => {
    if (equipmentType === 'all_equipment') {
        return exercises;
    }
    return exercises.filter((rd) => rd.equipment_category === equipmentType);
};
const fuseScoreToSimilarity = (score) => {
    if (score === 0)
        return 'exact';
    if (score < 0.05)
        return 'extremely-similar';
    if (score < 0.3)
        return 'very-similar';
    if (score < 0.6)
        return 'somewhat-similar';
    return 'not-similar';
};
const getStringSimilarityScore = (searchString, targetString, fuseInstance) => {
    var _a, _b;
    fuseInstance.setCollection([targetString]);
    const result = fuseInstance.search(searchString);
    const score = (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.score) !== null && _b !== void 0 ? _b : 1.0;
    return score;
};
// Old filter exercise functionality, will be removed when new feature goes live
const filterExercisesWithSearchText = (searchText, exercises, language) => {
    if (searchText.length === 0) {
        return exercises;
    }
    return exercises.filter((e) => {
        const searchableSearchText = searchable(searchText);
        const searchableEnglishTitle = searchable(e.title);
        const searchableLocalizedTitleMap = !e.is_custom
            ? {
                en: searchable(e.title),
                es: e.es_title ? searchable(e.es_title) : undefined,
                de: e.de_title ? searchable(e.de_title) : undefined,
                fr: e.fr_title ? searchable(e.fr_title) : undefined,
                it: e.it_title ? searchable(e.it_title) : undefined,
                pt: e.pt_title ? searchable(e.pt_title) : undefined,
                tr: e.tr_title ? searchable(e.tr_title) : undefined,
                zh_CN: e.zh_cn_title ? searchable(e.zh_cn_title) : undefined,
                zh_TW: e.zh_tw_title ? searchable(e.zh_tw_title) : undefined,
                ru: e.ru_title ? searchable(e.ru_title) : undefined,
                ja: e.ja_title ? searchable(e.ja_title) : undefined,
                ko: e.ko_title ? searchable(e.ko_title) : undefined,
            }
            : {
                en: searchable(e.title),
            };
        const searchableLocalizedTitle = searchableLocalizedTitleMap[language] || searchableLocalizedTitleMap.en;
        const searchableLocalizedMuscleGroupName = searchable(e.localized_muscle_group_name);
        const searchableMuscleGroup = searchable(e.muscle_group);
        const searchableMisspelledDumbbellEquipment = e.equipment_category === 'dumbbell' ? 'dumbell' : '';
        const searchableTags = !e.is_custom && e.manual_tag ? searchable(e.manual_tag) : '';
        const searchableAka = !e.is_custom && e.aka ? searchable(e.aka) : '';
        if (searchableLocalizedTitle.includes(searchableSearchText) ||
            searchableEnglishTitle.includes(searchableSearchText) ||
            searchableLocalizedMuscleGroupName.includes(searchableSearchText) ||
            searchableMuscleGroup.includes(searchableSearchText)) {
            return true;
        }
        if (e.is_custom && 'custom'.includes(searchableSearchText)) {
            return true;
        }
        const splitSearch = searchableSearchText.split(' ');
        const splitTitle = [
            searchableLocalizedTitle,
            searchableEnglishTitle,
            searchableTags,
            searchableAka,
            searchableMisspelledDumbbellEquipment,
        ]
            .join(' ')
            .split(' ');
        // Find:
        // title ['arnold', 'press', '(barbell)']
        // search ['press', 'bar']
        if ((0, lodash_1.intersectionWith)(splitSearch, splitTitle, (search, title) => title.includes(search)).length === splitSearch.length) {
            return true;
        }
        return false;
    });
};
const newFilterExercisesWithSearchText = (fuseInstance, searchText, exercises, language, 
// 0 means no penalty, 1 means don't match muscle groups (because a score > 1 means no match)
muscleGroupMatchPenalty) => {
    if (searchText.length === 0) {
        return exercises;
    }
    return exercises.reduce((accu, e) => {
        const searchableSearchText = searchable(searchText);
        const searchableEnglishTitle = searchable(e.title);
        const searchableLocalizedTitleMap = !e.is_custom
            ? {
                en: searchable(e.title),
                es: e.es_title ? searchable(e.es_title) : undefined,
                de: e.de_title ? searchable(e.de_title) : undefined,
                fr: e.fr_title ? searchable(e.fr_title) : undefined,
                it: e.it_title ? searchable(e.it_title) : undefined,
                pt: e.pt_title ? searchable(e.pt_title) : undefined,
                tr: e.tr_title ? searchable(e.tr_title) : undefined,
                zh_CN: e.zh_cn_title ? searchable(e.zh_cn_title) : undefined,
                zh_TW: e.zh_tw_title ? searchable(e.zh_tw_title) : undefined,
                ru: e.ru_title ? searchable(e.ru_title) : undefined,
                ja: e.ja_title ? searchable(e.ja_title) : undefined,
                ko: e.ko_title ? searchable(e.ko_title) : undefined,
            }
            : {
                en: searchable(e.title),
            };
        const searchableLocalizedTitle = searchableLocalizedTitleMap[language] || searchableLocalizedTitleMap.en;
        const searchableLocalizedMuscleGroupName = searchable(e.localized_muscle_group_name);
        const searchableMuscleGroup = searchable(e.muscle_group);
        const searchableMisspelledDumbbellEquipment = e.equipment_category === 'dumbbell' ? 'dumbell' : '';
        const searchableTags = !e.is_custom && e.manual_tag ? searchable(e.manual_tag) : '';
        const searchableAka = !e.is_custom && e.aka ? searchable(e.aka) : '';
        const englishSimilarityScore = getStringSimilarityScore(searchableSearchText, searchableEnglishTitle, fuseInstance);
        const localizedSimilarityScore = getStringSimilarityScore(searchableSearchText, searchableLocalizedTitle, fuseInstance);
        let englishMuscleGroupSimilarityScore = 1;
        let muscleGroupSimilarityScore = 1;
        if (muscleGroupMatchPenalty < 1) {
            englishMuscleGroupSimilarityScore = getStringSimilarityScore(searchableSearchText, searchableMuscleGroup, fuseInstance);
            muscleGroupSimilarityScore = getStringSimilarityScore(searchableSearchText, searchableLocalizedMuscleGroupName, fuseInstance);
        }
        // We always return the best score, regardless of where the match happens
        const bestScore = Math.min(englishSimilarityScore, localizedSimilarityScore, englishMuscleGroupSimilarityScore + muscleGroupMatchPenalty, muscleGroupSimilarityScore + muscleGroupMatchPenalty);
        if (fuseScoreToSimilarity(englishSimilarityScore) !== 'not-similar') {
            accu.push(Object.assign(Object.assign({}, e), { searchStringScore: bestScore }));
            return accu;
        }
        if (fuseScoreToSimilarity(localizedSimilarityScore) !== 'not-similar') {
            accu.push(Object.assign(Object.assign({}, e), { searchStringScore: bestScore }));
            return accu;
        }
        if (['exact', 'extremely-similar'].includes(fuseScoreToSimilarity(englishMuscleGroupSimilarityScore))) {
            accu.push(Object.assign(Object.assign({}, e), { searchStringScore: bestScore }));
            return accu;
        }
        if (['exact', 'extremely-similar'].includes(fuseScoreToSimilarity(muscleGroupSimilarityScore))) {
            accu.push(Object.assign(Object.assign({}, e), { searchStringScore: bestScore }));
            return accu;
        }
        if (e.is_custom && 'custom'.includes(searchableSearchText)) {
            accu.push(e);
            return accu;
        }
        const splitSearch = searchableSearchText.split(' ');
        const splitTitle = [
            searchableLocalizedTitle,
            searchableEnglishTitle,
            searchableTags,
            searchableAka,
            searchableMisspelledDumbbellEquipment,
        ]
            .join(' ')
            .split(' ');
        // Find:
        // title ['arnold', 'press', '(barbell)']
        // search ['press', 'bar']
        if ((0, lodash_1.intersectionWith)(splitSearch, splitTitle, (search, title) => title.includes(search)).length === splitSearch.length) {
            accu.push(e);
            return accu;
        }
        return accu;
    }, []);
};
const orderExercisesWithSearchText = (searchText, exercises) => {
    if (searchText.length === 0) {
        return exercises;
    }
    return exercises
        .reduce((accu, currentExercise) => {
        const lowercaseTitle = currentExercise.title.toLowerCase();
        if (lowercaseTitle.startsWith(searchText)) {
            accu.push({
                exercise: currentExercise,
                weight: currentExercise.priority * 2,
            });
            return accu;
        }
        accu.push({
            exercise: currentExercise,
            weight: currentExercise.priority,
        });
        return accu;
    }, [])
        .sort((a, b) => b.weight - a.weight)
        .map((a) => a.exercise);
};
/**
 * trims, lowercases and removes trailing "s" character to
 * simplify english searches
 */
const normalizeSearchText = (searchText, language) => {
    const searchableSearchText = searchable(searchText).replace('-', ' ').trim();
    if (language !== 'en')
        return searchableSearchText;
    if (searchableSearchText.length < 3)
        return searchableSearchText;
    const lastCharacter = searchableSearchText.slice(-1);
    if (lastCharacter !== 's')
        return searchableSearchText;
    return searchableSearchText.slice(0, -1);
};
const searchable = (str) => {
    return (0, utils_1.removeAccents)(str.toLowerCase());
};
/**
 * Exercise templates that are shown at the top of the Exercise Library to
 * users who don't have any workouts logged.
 */
exports.popularExerciseTemplateIds = [
    'B8127AD1', // Lying Leg Curl (Machine)"
    '11A123F3', // Seated Leg Curl (Machine)"
    'D04AC939', // Squat (Barbell)"
    '75A4F6C4', // Leg Extension (Machine)"
    '422B08F1', // Lateral Raise (Dumbbell)"
    'C7973E0E', // Leg Press (Machine)"
    '07B38369', // Incline Bench Press (Dumbbell)"
    '3601968B', // Bench Press (Dumbbell)"
    '6A6C31A5', // Lat Pulldown (Cable)"
    '0393F233', // Seated Cable Row - V Grip (Cable)"
    '37FCC2BB', // Bicep Curl (Dumbbell)"
    '55E6546F', // Bent Over Row (Barbell)"
    '94B7239B', // Triceps Rope Pushdown"
    'C6272009', // Deadlift (Barbell)"
    '878CD1D0', // Shoulder Press (Dumbbell)"
    '651F844C', // Cable Fly Crossovers"
    '79D0BB3A', // Bench Press (Barbell)"
    '93A552C6', // Triceps Pushdown"
    '7E3BC8B6', // Hammer Curl (Dumbbell)"
    'BE640BA0', // Face Pull
];
